import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import resurfacing from './modules/resurfacing'
import maintenance from './modules/maintenance'
import defects from './modules/defects'
import userSystemLevels from './modules/userSystemLevels'

import waterNetworkElements from './modules/waterNetworkElements'
import waterNetworkWaterNode from './modules/waterNetworkWaterNode'
import waterNetworkWaterPipe from './modules/waterNetworkWaterPipe'
import waterNetworkGateValve from './modules/waterNetworkGateValve'

import hml from './modules/hml'

import createLogger from 'vuex/dist/logger'

export default new Vuex.Store({
    modules: {
        resurfacing,
        maintenance,
        defects,
        userSystemLevels,

        waterNetworkElements,
        waterNetworkWaterNode,
        waterNetworkWaterPipe,
        waterNetworkGateValve,
        
        hml
    },
    plugins:  [createLogger()],
    strict:false
})


// WEBPACK FOOTER //
// ./src/store/index.js